import Step from './step';
import {createElement} from 'methods/utils';
import Select from 'components/select';
import NotificationStep from './notification-step';
import FormErrorsMixin from '../form-errors-mixin';
import {isGoogleMail, isGoogleRegistrationBlockedResponse, showGoogleMailBlockedModal} from '../google-auth-blocked';

function EmailRegisterStep(modal, options = {}) {
    const className = 'EmailRegisterStep';
    const $element = createElement(
        `<div class="${className}">
            <div class="${className}__wrapper">
                <form action="/users_v2/registration/" method="POST">
                    <input type="hidden" name="profile_type" value="1">
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">Имя</label>
                        <div class="${className}__input-group">
                            <input class="${className}__input" type="text" name="name">
                        </div>
                    </div>
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">E-mail</label>
                        <div class="${className}__input-group">
                            <input class="${className}__input" type="email" name="email">
                        </div>
                    </div>
                    <div class="${className}__input-block">
                        <label class="${className}__input-label">Мобильный телефон</label>
                        <div class="${className}__input-group">
                            <div class="${className}__select-wrapper js-country-select-wrapper"></div>
                            <div class="${className}__input-wrapper">
                                <input class="${className}__input" type="tel" name="phone">
                            </div>
                        </div>
                    </div>
                    <button class="${className}__submit js-submit">Зарегистрироваться</button>
                    <div class="${className}__policy">
                        <p>Авторизуясь, вы соглашаетесь с правилами использования сервиса и обработки <a href="/about/guest_offer/">персональных данных</a>.</p>
                        <p><a href="https://privettur.ru/about/obrabotka_personalnyh_dannyh/" target="_blank">Политика в отношении обработки персональных данных</a></p>
                        <p><a href="https://privettur.ru/about/soglasie_na_obrabotku_personalnyh_dannyh/" target="_blank">Согласие на обработку персональных данных</a></p>
                    </div>
                </form>
            </div>
        </div>`
    );

    Step.call(this, modal, $element, options);
    FormErrorsMixin.call(this);

    this.className = className;
    this.fieldsErorrs = [];

    this.$form = this.$element.querySelector('form');
    this.$form.addEventListener('submit', e => {
        e.preventDefault();
        this.submit();
    });

    this.$countrySelectWrapper = this.$element.querySelector('.js-country-select-wrapper');
    this.$phone = this.$element.querySelector('input[name="phone"]');

    this.formats = window.pageData.phone_formats.map(item => ({
        code: item.code,
        format: item.format,
        mask: item.format.replace(/\\d\{(\d+)\}/g, function(match, count) {
            return '0'.repeat(count);
        }),
    }));

    const items = this.formats.map(item => ({
        title: item.code,
        value: item.code,
    }));

    this.select = Select.make(items, {
        name: 'country',
        on: {
            select: (value, index) => {
                const format = this.formats.find(item => item.code == value);
                const startsWith = format.mask.match(/{?(\d+)}?/)[1];

                if (this.mask) {
                    this.mask.destroy();
                    this.$phone.value = '';
                }

                if (!this.$phone.value) {
                    this.$phone.value = startsWith;
                }

                this.mask = IMask(this.$phone, {
                    mask: format.mask,
                });
            },
        },
    });

    this.$countrySelectWrapper.appendChild(this.select.$element);

    this.$submit = this.$element.querySelector('.js-submit');
}

EmailRegisterStep.prototype = Object.create(Step.prototype);
Object.assign(EmailRegisterStep.prototype, FormErrorsMixin.prototype);
Object.defineProperty(EmailRegisterStep.prototype, 'constructor', {
    value: EmailRegisterStep,
    enumerable: false,
    writable: true,
});

EmailRegisterStep.prototype.submit = function() {
    const formData = new FormData(this.$form);
    const email = formData.get('email');

    this.resetFieldsErrors();

    if (isGoogleMail(email)) {
        showGoogleMailBlockedModal(this.modal);
        return;
    }

    this.$submit.classList.add('is-loading');

    return fetch(this.$form.action, {
        method: this.$form.method,
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        if (isGoogleRegistrationBlockedResponse(r)) {
            showGoogleMailBlockedModal(this.modal);
            return;
        }

        if (r.status != 'ok') {
            this.showFieldsErrors(r.fields);
            return;
        }

        if (typeof this.nextStep == 'undefined') {
            this.nextStep = new NotificationStep(this.modal, {
                title: 'Регистрация завершена',
                description: `На почту ${this.$form.elements.email.value} был отправлен пароль для доступа в личный кабинет`,
            });
        }

        this.showStep(this.nextStep);
    }).finally(() => {
        this.$submit.classList.remove('is-loading');
    });
}

EmailRegisterStep.prototype.show = function() {
    this.modal.setTitle('Регистрация');
    this.modal.setCanPrevStep(true);

    const $footer = createElement(
        `<div class="${this.className}__login">
            Уже есть аккаунт? <a href="javascript:void(0);" class="js-login">Войти</a>
        </div>`
    );

    const $login = $footer.querySelector('.js-login');
    $login.addEventListener('click', e => {
        this.modal.prevStep();
    });

    this.modal.setFooterContent($footer);
}

export default EmailRegisterStep;
